import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { DT, DTMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DtFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DtFormComponent),
    },
  ],
  selector: 'app-dt-form',
  styleUrls: ['./dt-form.component.scss'],
  templateUrl: './dt-form.component.html',
})
export class DtFormComponent extends BaseCtrlValueAccessorFormArrayComponent<DT> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addDTHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage DT without a control');
    }

    const DTControl = this.formManager.makeForm(DTMeta, {});
    this.form.push(DTControl);
  }

  removeDTHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage DT without a control');
    }

    this.form.removeAt(index);
  }
}
